/**
 * @file
 * Содержит всю необходимую логику для работы модуля AccessibilityBlock.
 */

/**
 * @var {AccessibilitySettings} accessibilitySettings Настройки панели доступности.
 */
  let accessibilitySettings = undefined;

  /**
  * @typedef AccessibilitySettings 
  * @description Хранит настройки панели доступности 
  * @type {Object}
  * 
  * @property {number} fontSize 
  * @property {number} intervalSize
  * @property {boolean} pageImg
  * @property {boolean} blackFilter
  * @property {boolean} accessibilityMode
  * @property {ColorTheme} colorTheme
  */

  /**
  * @typedef ColorTheme 
  * @description Хранит тип цветовой схемы страницы
  * @type {Object}
  * 
  * @property {'schemeYellowONblue'|'schemeWhiteONblack'|'schemeBlackONwhite'} id 
  */

(function (Drupal, once, $, cookie) {
  
  'use strict';

  /**
   * @var {HTMLAudioElement} aud Плеер для воспроизведения справки.
   */
  let aud;
  
  $("#accessibility-block__switch-button").on('click',function () {
    onSwitchBtn();
  });
  $("#accessibility-block__switch-button2").on('click',function () {
    onSwitchBtn();
  });
  $("#accessibility-block__restore").on('click',function () {
    restoreSettings();
  });
  $("#chImgDisplay").on('click',function () {
    onChImgDisplay();
  });
  $("#chImgColor").on('click',function () {
    onChImgColor();
  });
  $(".button-font-size").on('click',function () {
    onChFontSize(this);
  });
  $(".button-interval-size").on('click',function () {
    onChIntervalSize(this);
  });
  $(".button-color-scheme").on('click',function () {
    onChColorScheme(this);
  });
  $("#accessibility-block__play-audio").on('click',function () {
     onAudioHelp(this)
  });
  

  let t = cookie.get('accessibilitySettings');
  if(t && t != "undefined") {
    try {
      accessibilitySettings = JSON.parse(t);
    } catch (e) {
      console.warn("Accessibility settings parse failed. Used defaults.");
    }
  }
  if(!accessibilitySettings) {
    restoreSettings(false);
  }
  if(accessibilitySettings.accessibilityMode) {
    accessibilityMode();
    applyFontSize();
    applyIntervalSize();
    applyColorScheme();
    applyImgDisplay();
    applyImgColor();
    chPanelHeight();
  }
  else {
    normalMode();
  }
  
  window.addEventListener("resize",
    function() {
      if(accessibilitySettings && accessibilitySettings.accessibilityMode != false) {
        chPanelHeight();
      }
    },
    {
      once:false,
      passive:true
    }
  );

  /**
   * Сбрасывает настройки доступности страницы. По умолчанию перезагружает
   * страницу при применении настроек.
   *
   * @param {boolean} [reloadPage = true] Устанавливает необходимость перезагрузки
   * станицы при применении настроек.
   */
  function restoreSettings(reloadPage = true){
    accessibilitySettings = {
      fontSize : 20,
      intervalSize : 30,
      pageImg : true,
      blackFilter : false,
      accessibilityMode : false,
      colorTheme : {id : null,},
    };
    if(reloadPage){
      accessibilitySettings.accessibilityMode = true;
      saveSettings();
      location.reload();
    } else {
      saveSettings();
      chPanelHeight();
    }
  }

  /**
   * Сохраняет JSON c настройками в cookie браузера.
   */
  function saveSettings(){
    cookie.set('accessibilitySettings',JSON.stringify(accessibilitySettings),{expires:30,path: '/'});
  }

  /**
   * Сдвигает контент страницы на высоту панели доступности.
   */
  function chPanelHeight() {
    if(accessibilitySettings.accessibilityMode) {
      let $panel = $("#accessibility-panel"),
        $adminToolBar = $("#toolbar-administration"),
        height=$panel.innerHeight();
      if ($adminToolBar.length != 0 ) {
        height += $adminToolBar.innerHeight();
        $("#toolbar-bar").css("top",$($("#accessibility-panel")).innerHeight()+"px");
      }
      $("body").css('margin-top',height+"px");
      if (typeof Drupal.olivero !== 'undefined') {
        $("*",$("#header")).removeClass("all-block");
        $("#header").removeClass("all-block");
      }
    }
  }

  /**
   * Обработчик события click кнопки переключения режима доступности страницы.
   * Перезагружает страницу при переходе в обычный режим.
   */
  function onSwitchBtn() {
    if(accessibilitySettings.accessibilityMode) {
      accessibilitySettings.accessibilityMode = false;
      saveSettings();
      normalMode();
      location.reload();
    }
    else {
      accessibilitySettings.accessibilityMode = true;
      saveSettings();
      applyFontSize();
      applyIntervalSize();
      applyColorScheme();
      applyImgDisplay();
      applyImgColor();
      accessibilityMode();
      chPanelHeight();
    }
  }

  /**
   * Переводит страницу в режим доступности.
   */
  function accessibilityMode() {
    $("body").prepend($("#accessibility-panel"));
    $("#accessibility-panel").removeClass("accessibility-block__control-panel_hide");
    $("*").addClass("all-block");
  }

  /**
   * Переводит страницу в обычный режим.
   */
  function normalMode() {
    $("#accessibility-panel").addClass("accessibility-block__control-panel_hide");
    $("*").removeClass("all-block");
  }

  /**
   * Воспроизводит аудио-файл со справкой.
   *
   * @param {HTMLInputElement} button Нажимаемая кнопка.
   */
  function onAudioHelp(button) {
    if(button.value == "Воспроизвести") {
      if(button.dataset.src) {
        aud = new Audio(button.dataset.src);
        aud.play();
      } else {
        console.log("Audio help not found");
      }
      button.value = "Остановить";
    } else {
      aud.pause();
      aud.currentTime = 0;
      button.value = "Воспроизвести";
    }
  }

  /**
   * Обработчик события нажатия на кнопку смены цветовой схемы изображений.
   */
  function onChImgColor(){
    accessibilitySettings.blackFilter = !accessibilitySettings.blackFilter;
    applyImgColor();
    saveSettings();
  }

  /**
   * Накладывает/снимает чёрно-белый фильтр на изображения.
   */
  function applyImgColor() {
    let $btn = $("#chImgColor");
    if(accessibilitySettings.blackFilter) {
      $btn.attr("value",'Цвет');
      $('img').css('filter','grayscale(100%)');
    } else {
      $btn.attr("value",'Ч/Б');
      $('img').css('filter','none');
    }
  }

  /**
   * Обработчик события нажатия на кнопку смены отображения  изображений.
   */
  function onChImgDisplay(){
    accessibilitySettings.pageImg=!accessibilitySettings.pageImg;
    applyImgDisplay();
    saveSettings();
  }

  /**
   * Включает/выключает отображение изображений на странице.
   */
  function applyImgDisplay() {
    let $btn = $("#chImgDisplay");
    if(accessibilitySettings.pageImg) {
      $btn.attr("value",'Выкл')
      $('img').css('display','block');
      $('#chImgColor').removeClass("control__button_hide");
    } else {
      $btn.attr("value",'Вкл');
      $('img').css('display','none');
      $('#chImgColor').addClass("control__button_hide");
    }
  }

  /**
   * Обработчик события нажатия на кнопку смены цветовой схемы страницы.
   *
   * @param {HTMLInputElement} obj Нажатая кнопка.
   */
  function onChColorScheme(obj){
    accessibilitySettings.colorTheme.id = obj.id;
    applyColorScheme();
    saveSettings();
  }

  /**
   * Применяет цветовую схему страницы.
   */
  function applyColorScheme() {
    if(accessibilitySettings.colorTheme==undefined || !accessibilitySettings.colorTheme.id)
      return;
    switch (accessibilitySettings.colorTheme.id) {
      case "schemeBlackONwhite":
        $("*").css({
          "background-color": "#fff",
          "color": "#000"
        });
        break;
      case "schemeWhiteONblack":
        $("*").css({
          "background-color": "#000",
          "color": "#fff"
        });
        break;
      case "schemeYellowONblue":
        $("*").css({
          "background-color": "#0000FF",
          "color": "#FFFF00"
        });
        break;
      default:
        console.error("colorTheme.id is " + accessibilitySettings.colorTheme.id);
        break;
    }
  }

  /**
   * Обработчик события нажатия на кнопку смены размера интервала.
   *
   * @param {HTMLInputElement} obj Нажатая кнопка.
   */
  function onChIntervalSize(obj){
    if(obj) {
      if (obj.value == "+") {
        accessibilitySettings.intervalSize >= 60 ? accessibilitySettings.intervalSize = 60 :  accessibilitySettings.intervalSize += 10;
      }
      else {
        accessibilitySettings.intervalSize <= 10 ? accessibilitySettings.intervalSize = 10 : accessibilitySettings.intervalSize -= 10;
      }
      applyIntervalSize();
      chPanelHeight();
      saveSettings();
    } else {
      console.error("Interval obj is " + obj);
    }
  }

  /**
   * Применяет выбранный межстрочный интервал для текста на странице.
   */
  function applyIntervalSize(){
    $("*").css('lineHeight',accessibilitySettings.intervalSize + "px");
    $("body").css('marginTop',$(".accessibility-block").css('offsetHeight') + "px");
  }

  /**
   * Обработчик события нажатия на кнопку смены размера шрифта.
    *
  * @param {HTMLInputElement} obj Нажатая кнопка.
  */
  function onChFontSize(obj){
    if(obj) {
      if (obj.value == "a+") {
        accessibilitySettings.fontSize >= 40 ? accessibilitySettings.fontSize = 40 : accessibilitySettings.fontSize += 10;
      }
      else {
        accessibilitySettings.fontSize <= 10 ? accessibilitySettings.fontSize = 10 : accessibilitySettings.fontSize -= 10;
      }
      applyFontSize();
      chPanelHeight();
      saveSettings();
    } else {
      console.error("FontSize obj is " + obj);
    }
  }

  /**
   * Применяет выбранный размер шрифта для текста на странице.
   */
  function applyFontSize(){
    $("*").css('fontSize',accessibilitySettings.fontSize + "px");
    $("body").css('marginTop',$(".accessibility-block").css('offsetHeight') + "px");
  }

} (Drupal, once, jQuery, window.Cookies));
